export const cardClass = "bg-white rounded-xl border border-gray-200 shadow-sm";
export const cardMutedClass = "bg-gray-50 rounded-xl border border-gray-200";
export const cardBodyClass = "p-4";
export const cardBodyLgClass = "p-6";
export const cardHeaderClass =
  "flex items-center justify-between gap-4 border-b border-gray-200 px-4 py-4";
export const cardHeaderTitleClass = "text-lg font-semibold text-gray-900";

export const tableWrapperClass = "overflow-x-auto";
export const tableClass = "w-full";
export const tableCompactClass = "w-full text-sm";
export const tableHeadClass = "bg-gray-50";
export const tableHeaderCellClass =
  "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500";
export const tableHeaderCellCenterClass =
  "px-6 py-3 text-center text-xs font-medium uppercase tracking-wider text-gray-500";
export const tableHeaderCellRightClass =
  "px-6 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500";
export const tableBodyClass = "divide-y divide-gray-200";
export const tableRowClass = "hover:bg-gray-50";
export const tableCellClass = "px-6 py-4 text-sm text-gray-700";
export const tableCellMutedClass = "px-6 py-4 text-sm text-gray-500";
export const tableCellStrongClass =
  "px-6 py-4 text-sm font-medium text-gray-900";
export const tableEmptyStateClass = "p-8 text-center text-gray-500";
